import { render, staticRenderFns } from "./TabularMultiplication.vue?vue&type=template&id=02a4c65e&lang=pug&"
import script from "./TabularMultiplication.vue?vue&type=script&lang=js&"
export * from "./TabularMultiplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports